// extracted by mini-css-extract-plugin
export var linkText = "_nb-0";